module.exports = __webpack_public_path__ + "static/media/whatsapp.4719d0ab.svg";